import { render } from "./PromiseIcon3.vue?vue&type=template&id=775f9553"
import script from "./PromiseIcon3.vue?vue&type=script&lang=js"
export * from "./PromiseIcon3.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/GB-Frontend/GB-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__